export default { version: '7.18.1' };
